import { takeLatest, put, call, select } from 'redux-saga/effects';
import { ADD_WORKOUT_BY_AVAILABLE_SUBSCRIPTION_SAGA, GET_AVAILABLE_SUBSCRIPTIONS_SAGA } from "../sagaTypes";
import { loaderAction, setAvailableSubscriptionsFormAction } from "../rootReducer";
import { url } from "../../config";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { AVAILABLE_SUBSCRIPTION__FORM_INITIAL } from "../initialStateConstant";
import { getBookingUsersSagaAction } from "../sagaActions";

const request = data => {
    return fetch(`${ url }/add_workout_by_available_subscription`, {
        method: 'post',
        body: data
    })
        .then(response => response.json()).catch(error => console.log(error))
};

function* workerAddWorkoutByAvailableSubscription(args) {
    const user = yield select(state => state.user);

    yield put(loaderAction(true));
    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('subscription_id', args.data.subscription_id);
        formData.append('booking_id', args.data.booking_id);

        const response = yield call (request, formData);

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму списания тренировки
            yield put(setAvailableSubscriptionsFormAction(AVAILABLE_SUBSCRIPTION__FORM_INITIAL));
            // Обновляем список записанных пользователей
            yield put(getBookingUsersSagaAction({
                booking_id: args.data.booking_id
            }));

            growl({ type: 'success', message: response.message });
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
        yield put(loaderAction(false));
    }
    finally {
        yield put(loaderAction(false));
    }
}

export default function* watcherAddWorkoutByAvailableSubscription() {
    yield takeLatest(ADD_WORKOUT_BY_AVAILABLE_SUBSCRIPTION_SAGA, workerAddWorkoutByAvailableSubscription);
}